module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_43.450b1ba2.jpg";